import { render } from "./parentInfo.vue?vue&type=template&id=37874fde"
import script from "./parentInfo.vue?vue&type=script&lang=js"
export * from "./parentInfo.vue?vue&type=script&lang=js"

import "./parentInfo.vue?vue&type=style&index=0&id=37874fde&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__